/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-14T10:27:59.786Z by lizhutang (lizhutang@spolo.org)

'use strict'

function onAutoStyleChanged (styleKey, value) {
  // console.log('value=', value)
  let self = this
  let em = self.target.em
  let modelToStyle = em.get('StyleManager').getModelToStyle(self.target)
  let style = modelToStyle.getStyle()
  if (value === 'none') {
    style[styleKey] = '100%'
  } else if (style[styleKey]) {
    delete style[styleKey]
  }

  modelToStyle.setStyle(style, { avoidStore: 1 })
  const updateEvent = `update:component:style`
  em && em.trigger(
    `${updateEvent}:${styleKey}`
  )
  modelToStyle.trigger('change:style', modelToStyle, style, {})
}

function getChildItems (childType, childName) {
  let self = this
  let retArray = [ { value: 'none', name: '无' } ]
  $(self.target.view.el).children(`[lj-type=${childType}]`).each(function () {
    // console.log('item=', this)
    let name = this.getAttribute('lj-name') || this.id
    if (name) {
      retArray.push({
        value: name,
        name: `${name}${childName}`
      })
    }
  })
  // console.log('self.model', self.model)
  return retArray
}

function onInsertStage (editor, model) {
  // console.log('row=', editor.BlockManager.get('row'))
  // console.log('model parent=', model.parent().get('type'))
  let style = { 'width': '100%' }
  if (model.parent().get('type') === 'wrapper') {
    style.height = '100vh'
  } else {
    style.height = `${$(model.parent().view.el).height()}px`
  }
  model.setStyle(style)
  model.get('components').add('<div lj-type="layer" style="width:100%;height:100%"></div>')
}

function onInsertLayer (editor, model) {
  model.get('components').add('<div lj-type="frame" style="width:100%;height:100%" data-child-element="basic"></div>')
}
function onInsertAbsolute (editor, model) {
  let parentModel = model.parent()
  let setRelativeModel = parentModel
  while (parentModel) {
    let attrs = parentModel.getAttributes() || {}
    let csses = parentModel.getStyle() || {}
    if (csses['position'] === 'relative' || attrs['lj-type'] || attrs['data-lj-type']) {
      setRelativeModel = undefined
    }
    parentModel = parentModel.parent()
  }
  if (setRelativeModel) {
    let css = setRelativeModel.getStyle() || {}
    css['position'] = 'relative'
    setRelativeModel.setStyle(css)
  }
}

function onInsertFrame (editor, model) {
  model.get('components').add({
    type: 'text',
    tagName: 'p',
    content: '这里是占位文字，方便您快速修改：WIDE是WWARE的集成开发环境。在人工智能技术的支持下，可以快速开发复杂逻辑的智能应用。支持开发标准HTML5应用，微信/易信应用，APP(Android，iOS，WinPhone)，智能电视，标准PC软件(Windows,Linux,Mac OS)的开发。其假想用户为领域专家，以函数编程为主要思路，会用计算器就可以快速开发复杂逻辑的应用。整个开发过程不要求有任何的计算机语言基础。'
  })
}

const ljNoScolling = {
  type: 'checkbox',
  label: '禁用滚动条',
  name: 'lj-no-scrolling'
}
const ljName = {
  type: 'text',
  label: '名称',
  name: 'lj-name',
  placeholder: '名称优先级高于元素ID'
}
const ljFitTo = {
  type: 'select',
  label: '尺寸',
  options: [
    { value: 'fixed', name: '自身(父)尺寸' },
    { value: 'width', name: '缩放至画布容器宽' },
    { value: 'height', name: '缩放至画布容器高' },
    { value: 'responsive-width', name: '与画布容器等宽' },
    { value: 'responsive-height', name: '与画布容器等高' },
    { value: 'repsonsive', name: '与画布容器相同尺寸' },
    { value: 'elastic-width', name: '弹性区宽度' },
    { value: 'elastic-height', name: '弹性区高度' }
  ],
  name: 'lj-fit-to'
}
const ljStartPosition = {
  type: 'select',
  label: '开始位置',
  options: [
    { value: 'top', name: '上边框对齐' },
    { value: 'bottom', name: '下边框对齐' },
    { value: 'left', name: '左边框对齐' },
    { value: 'right', name: '右边框对齐' },
    { value: 'middle', name: '中竖线对齐' },
    { value: 'center', name: '中横线对齐' },
    { value: 'top-left', name: '左上角对齐' },
    { value: 'top-right', name: '右上角对齐' },
    { value: 'bottom-left', name: '左下角对齐' },
    { value: 'bottom-right', name: '右下角对齐' },
    { value: 'middle-center', name: '中心点对齐' }
  ],
  name: 'lj-start-position'
}

const ljTransition = {
  type: 'select',
  label: '切换动画',
  options: [
    { value: 'left', name: '左滑入' },
    { value: 'right', name: '右滑入' },
    { value: 'up', name: '上滑入' },
    { value: 'down', name: '下滑入' },
    { value: 'fade', name: '渐隐' },
    { value: 'blur', name: '模糊' },
    { value: 'zoomin', name: '放大' },
    { value: 'zoomout', name: '缩小' },
    { value: 'slideOverLeft', name: '左滑出' },
    { value: 'slideOverRight', name: '右滑出' },
    { value: 'slideOverUp', name: '上滑出' },
    { value: 'slideOverDown', name: '下滑出' },
    { value: 'none', name: '无' }
  ],
  name: 'lj-transition'
}

function updateStyleSize (editor, comp, selectedHandler, config) {
  let xcoord, ycoord, posunit, xname, yname, rmx, rmy
  let postype = comp.getAttributes()['data-position-type'] || 'lt'
  let $comp = $(comp.view.el)
  let $parent = $(comp.parent().view.el)
  let compPos = $comp.position()
  const compWidth = $comp.width()
  const compHeight = $comp.height()
  const parentWidth = $parent.width()
  const parentHeight = $parent.height()
  const updateEvent = `update:component:style`
  let evtStr = ''
  let addEvt = function (evtName) {
    if (evtStr) {
      evtStr += ' '
    }
    evtStr += `${updateEvent}:${evtName}`
  }

  compPos.right = compPos.left + compWidth
  compPos.bottom = compPos.top + compHeight
  if (postype.indexOf('lt') >= 0) {
    xname = 'left'
    yname = 'top'
    rmx = 'right'
    rmy = 'bottom'
  } else {
    xname = 'right'
    yname = 'bottom'
    rmx = 'left'
    rmy = 'top'
  }
  if (postype.indexOf('abs') >= 0) {
    posunit = 'px'
    xcoord = compPos[xname].toFixed(2)
    ycoord = compPos[yname].toFixed(2)
    if (xname !== 'left') {
      xcoord = parentWidth - xcoord
      ycoord = parentHeight - ycoord
    }
  } else {
    posunit = '%'
    xcoord = (100.0 * compPos[xname] / parentWidth)
    ycoord = (100.0 * compPos[yname] / parentHeight)
    if (xname !== 'left') {
      xcoord = (100.0 - xcoord)
      ycoord = 100.0 - ycoord
    }
    xcoord = xcoord.toFixed(2)
    ycoord = ycoord.toFixed(2)
  }
  // editor.trigger('change:canvasOffset')

  let em = comp.em
  let modelToStyle = em.get('StyleManager').getModelToStyle(comp)
  const style = modelToStyle.getStyle()

  if (parseFloat(xcoord) !== parseFloat(0)) {
    style[xname] = `${xcoord}${posunit}`
    addEvt(xname)
  }
  if (parseFloat(ycoord) !== parseFloat(0)) {
    style[yname] = `${ycoord}${posunit}`
    addEvt(yname)
  }
  if (style[rmx]) {
    delete style[rmx]
    addEvt(rmx)
  }
  if (style[rmy]) {
    delete style[rmy]
    addEvt(rmy)
  }

  if (selectedHandler) {
    let absize = (comp.getAttributes()['data-size-type'] === 'absolute')
    let width, height
    if (absize) {
      width = compWidth.toFixed(2)
      height = compHeight.toFixed(2)
    } else {
      width = (100.0 * compWidth / parentWidth).toFixed(2)
      height = (100.0 * compHeight / parentHeight).toFixed(2)
    }

    const onlyHeight = ['tc', 'bc'].indexOf(selectedHandler) >= 0
    const onlyWidth = ['cl', 'cr'].indexOf(selectedHandler) >= 0

    const {
      keyHeight,
      keyWidth,
      autoHeight,
      autoWidth
    } = config
    if (!onlyHeight) {
      style[keyWidth] = autoWidth ? 'auto' : `${width}${absize ? 'px' : '%'}`
      addEvt(keyWidth)
    }
    if (!onlyWidth) {
      style[keyHeight] = autoHeight ? 'auto' : `${height}${absize ? 'px' : '%'}`
      addEvt(keyHeight)
    }
  }

  // 不使用getSelectedToStyle(modelToStyle),因此只影响本元素，参见https://github.com/artf/grapesjs/issues/1388
  // comp.removeStyle('right')
  // comp.removeStyle('bottom')
  // comp.setStyle(styleObj)
  modelToStyle.setStyle(style, { avoidStore: 1 })
  // $('.gjs-resizer-c').css({ 'display': 'block' })
  console.log('evtstr=', evtStr)
  em && em.trigger(evtStr)
  modelToStyle.trigger('change:style', modelToStyle, style, {})
}

export default (editor, config = {}) => {
  const c = config
  let domc = editor.DomComponents
  let blocks = c.blocks

  var defaultType = domc.getType('default')
  var defaultModel = defaultType.model
  var defaultView = defaultType.view

  editor.on('component:add', function (model) {
    if (model.get('components').length > 0) {
      // 只处理没有孩子的情况。
      return
    }
    switch (model.get('type')) {
      case 'stage':
        onInsertStage(editor, model)
        break
      case 'layer':
        onInsertLayer(editor, model)
        break
      case 'absolute':
        onInsertAbsolute(editor, model)
        break
      case 'frame':
        onInsertFrame(editor, model)
        break
    }
  })

  // 使用 https://codepen.io/Shikkediel/pen/VLZKor 类似方式来处理拖动。
  // function dragMoveListener (event) {
  //   console.log('resizemove:0', event)
  // }
  // editor.on('component:selected', function (model) {
  //   if (model.get('type') === 'layer') {
  //     let win = editor.Canvas.getWindow()
  //     console.log(win.interact)
  //     window.interact(model.view.el).draggable({
  //       onmove: dragMoveListener,
  //       restrict: {
  //         restriction: 'parent',
  //         elementRect: { top: 0, left: 0, bottom: 0, right: 0 }
  //       }
  //     }).resizable({
  //       // resize from all edges and corners
  //       edges: { left: true, right: true, bottom: true, top: true },
  //
  //       // keep the edges inside the parent
  //       restrictEdges: {
  //         outer: 'parent',
  //         endOnly: true
  //       },
  //
  //       // minimum size
  //       restrictSize: {
  //         min: { width: 1, height: 1 }
  //       },
  //
  //       inertia: true
  //     })
  //     console.log('model.view=', model.view)
  //   }
  // })

  if (blocks.stage) {
    domc.addType('stage', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': wwjs.i18n('画布容器'),
          tagName: 'div',
          draggable: '#wrapper, .col, [data-wwtype=absolute]',
          droppable: true,
          copyable: false,
          traits: [
            // {
            //   type: 'text',
            //   label: '名称',
            //   name: 'lj-name',
            //   placeholder: '名称优先级高于元素ID'
            // },
            {
              type: 'attr_select',
              options: function () {
                return getChildItems.call(this, 'layer', '画布块')
              },
              onValueChanged: function (value) {
                return onAutoStyleChanged.call(this, 'width', value)
              },
              defopt: 'none',
              attr: 'lj-auto-width',
              label: '与画布块等宽'
            },
            {
              type: 'attr_select',
              options: function () {
                return getChildItems.call(this, 'layer', '画布块')
              },
              onValueChanged: function (value) {
                return onAutoStyleChanged.call(this, 'height', value)
              },
              defopt: 'none',
              attr: 'lj-auto-height',
              label: '与画布块等高'
            }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el && el.getAttribute && (el.getAttribute('lj-type') === 'stage')) {
            return { type: 'stage' }
          }
        }
      }),
      view: defaultView.extend({
      // onRender () {
      //   $(this.el).css('min-height', '100vh')
      //   if ($.isFunction(defaultView.onRender)) {
      //     defaultView.onRender.apply(this, arguments)
      //   }
      // },
        events: {
          click: function () {
            // console.log('on click:', arguments)
          },
          dblclick: function () {
            // $(this.el).focus()
            // console.log('on dbclick:', arguments)
          }
        // ,
        // focusout: function () {
        //   console.log('on focusout', arguments)
        // }
        }
      })
    })

    let toggleBodyClass = (resizer, method, e, opts) => {
      const docs = opts.docs
      docs &&
        docs.forEach(doc => {
          const body = doc.body
          const cls = body.className || ''
          body.className = (method === 'add'
            ? `${cls} ${resizer.resizeClass}`
            : cls.replace(resizer.resizeClass, '')
          ).trim()
        })
    }
    domc.addType('layer', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': wwjs.i18n('画布块'),
          tagName: 'div',
          draggable: '[lj-type=stage]',
          droppable: true,
          traits: [
            ljName,
            ljNoScolling,
            {
              type: 'checkbox',
              label: '使用浏览器卷滚条',
              name: 'lj-native-scroll'
            },
            ljFitTo,
            ljStartPosition,
            ljTransition,
            {
              type: 'select',
              label: '内容显示方式',
              options: [
                { value: 'slide', name: '只显示一个' },
                { value: 'canvas', name: '画布坐标' }
              ],
              name: 'lj-layout'
            },
            {
              type: 'attr_select',
              options: function () {
                let ret = getChildItems.call(this, 'frame', '内容块')
                ret.unshift({
                  value: '_first', name: '第一个'
                })
                return ret
              },
              defopt: '_first',
              attr: 'lj-default-frame',
              label: '默认内容块'
            }
            // {
            //   type: 'attr_select',
            //   options: [
            //     { value: 'container', name: 'abcd' },
            //     { value: 'container-fluid', name: 'asdfe2咋' }
            //   ],
            //   attr: 'ljtype',
            //   label: 'Width'
            // }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el && el.getAttribute && (el.getAttribute('lj-type') === 'layer')) {
            return { type: 'layer' }
          }
        }
      }),
      view: defaultView.extend({
      // onRender () {
      //   $(this.el).css('min-height', '100vh')
      //   if ($.isFunction(defaultView.onRender)) {
      //     defaultView.onRender.apply(this, arguments)
      //   }
      // },
        events: {
          click: function () {
            // console.log('on click:', arguments)
          },
          dblclick: function () {
            $(this.el).focus()
            // console.log('on dbclick:', arguments)
          }
        // ,
        // focusout: function () {
        //   console.log('on focusout', arguments)
        // }
        }
      })
    })

    domc.addType('absolute', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': wwjs.i18n('绝对定位块'),
          tagName: 'div',
          draggable: '#wrapper, .col, [lj-type=frame]',
          droppable: true,
          resizable: {
            unitHeight: 'px',
            unitWidth: 'px',
            // ratioDefault: 0,
            onStart: function (e, opts = {}) {
              // see https://github.com/artf/grapesjs/blob/dev/src/utils/Resizer.js#L4-L50
              // @see https://github.com/artf/grapesjs/issues/730
              // console.log('onStart:', arguments)
              // console.log(this)
              const { el, /* config, */ resizer } = opts
              // const {
              //   keyHeight,
              //   keyWidth,
              //   currentUnit,
              //   keepAutoHeight,
              //   keepAutoWidth
              // } = config
              // const keyLeft = 'left'
              // const keyTop = 'top'
              let em = editor.getSelected().em
              // let model = !window._.isElement(el) ? el : em.getSelected()
              if (!resizer.resizeClass) {
                const emConfig = em ? em.get('Config') : ''
                const pfx = emConfig.stylePrefix || ''
                resizer.resizeClass = `${pfx}resizing`
              }
              toggleBodyClass(resizer, 'add', e, opts)
              // console.log('pos=', $(el).position(), 'width=', $(el).width(), 'height=', $(el).height())

              // resizer.modelToStyle = em.get('StyleManager').getModelToStyle(model)
              // const computedStyle = getComputedStyle(el)
              // const modelStyle = resizer.modelToStyle.getStyle()
              //
              // let currentWidth = modelStyle[keyWidth]
              // config.autoWidth = keepAutoWidth && currentWidth === 'auto'
              // if (isNaN(parseFloat(currentWidth))) {
              //   currentWidth = computedStyle[keyWidth]
              // }
              //
              // let currentHeight = modelStyle[keyHeight]
              // config.autoHeight = keepAutoHeight && currentHeight === 'auto'
              // if (isNaN(parseFloat(currentHeight))) {
              //   currentHeight = computedStyle[keyHeight]
              // }
              //
              // let currentLeft = modelStyle[keyLeft]
              // if (isNaN(parseFloat(currentLeft))) {
              //   currentLeft = computedStyle[keyLeft]
              // }
              // let currentTop = modelStyle[keyTop]
              // if (isNaN(parseFloat(currentTop))) {
              //   currentTop = computedStyle[keyTop]
              // }
              // resizer.startDim.w = parseFloat(currentWidth)
              // resizer.startDim.h = parseFloat(currentHeight)

              let $el = $(el)
              let pos = $el.position()
              resizer.showOffsets = 0
              resizer.rectDim.l = resizer.startDim.l = pos.left
              resizer.rectDim.t = resizer.startDim.t = pos.top
              resizer.rectDim.w = resizer.startDim.w = $el.width()
              resizer.rectDim.h = resizer.startDim.h = $el.height()

              // console.log('resizer.rectDim=', resizer.rectDim)

              // if (currentUnit) {
              //   config.unitHeight = getUnitFromValue(currentHeight)
              //   config.unitWidth = getUnitFromValue(currentWidth)
              // }
              resizer.opts.ratioDefault = 0
              if (!resizer.superclassMove) {
                resizer.onMove = resizer.onMove.bind(resizer)
                resizer.superclassMove = true

                if (!resizer.origCalc) {
                  resizer.origCalc = resizer.calc
                  resizer.calc = function (data) {
                    let box = this.origCalc(data)
                    box.l += this.startDim.l
                    box.t += this.startDim.t
                    // console.log(box)
                    return box
                  }
                }
              }
            },
            // onMove: function () {
            //   let self = this
            //   console.log('onMove:', arguments)
            //   console.log('onMove this:', self)
            // },
            onEnd: function (e, opts) {
              let self = this
              const { selectedHandler, config } = opts
              // console.log('this=', this, 'arguments=', arguments)
              toggleBodyClass(self, 'remove', e, opts)
              editor.trigger('change:canvasOffset')
              self.showOffsets = 1
              let comp = editor.getSelected()
              updateStyleSize(editor, comp, selectedHandler || 'tl', config)
            },
            updateTarget (el, rect, options = {}) {
              const { store, selectedHandler } = options
              // const {
              //   unitWidth,
              //   unitHeight
              // } = config
              const onlyHeight = ['tc', 'bc'].indexOf(selectedHandler) >= 0
              const onlyWidth = ['cl', 'cr'].indexOf(selectedHandler) >= 0
              if (!onlyHeight) {
                el.style.width = `${rect.w}px`
              }

              if (!onlyWidth) {
                el.style.height = `${rect.h}px`
              }
              el.style.left = `${rect.l}px`
              el.style.top = `${rect.t}px`

              if (store) {
              }
            },
            minDim: 1
          },
          traits: [
            {
              type: 'select',
              label: '位置单位',
              options: [
                { value: 'lt', name: '左上角相对坐标' },
                { value: 'rt', name: '右下角相对坐标' },
                { value: 'ltabs', name: '左上角绝对像素' },
                { value: 'rtabs', name: '右下角绝对像素' }
              ],
              name: 'data-position-type'
            },
            {
              type: 'select',
              label: '尺寸单位',
              options: [
                { value: 'relative', name: '相对父坐标的百分比' },
                { value: 'absolute', name: '像素绝对坐标' }
              ],
              name: 'data-size-type'
            }
            // {
            //   type: 'attr_select',
            //   options: [
            //     { value: 'container', name: 'abcd' },
            //     { value: 'container-fluid', name: 'asdfe2咋' }
            //   ],
            //   attr: 'ljtype',
            //   label: 'Width'
            // }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el && el.getAttribute && (el.getAttribute('data-wwtype') === 'absolute')) {
            return { type: 'absolute' }
          }
        }
      }),
      view: defaultView.extend({
      // onRender () {
      //   $(this.el).css('min-height', '100vh')
      //   if ($.isFunction(defaultView.onRender)) {
      //     defaultView.onRender.apply(this, arguments)
      //   }
      // },
        events: {
          click: function () {
            // console.log('on click:', arguments)
          },
          dblclick: function () {
            $(this.el).focus()
            // console.log('on dbclick:', arguments)
          },
          mousedown: 'handleStart',
          mousemove: 'handleMove',
          mouseup: 'handleEnd'
        // ,
        // focusout: function () {
        //   console.log('on focusout', arguments)
        // }
        },
        'handleStart': function (e) {
          let self = this
          if (editor.getSelected() !== self.model) {
            return
          }
          // console.log('e=', e)
          self.dragMove = (e.button === 0)
          if (self.dragMove) {
            let $e = $(e.target)
            self.dragInfo = {
              shift: e.shiftKey,
              startX: e.screenX,
              startY: e.screenY,
              initX: $e.position().left,
              initY: $e.position().top
            }
            if (e.shiftKey) {
              self.dragInfo.centerX = $e.offset().top - $(editor.Canvas.getWindow()).scrollTop() + $e.width() / 2
              self.dragInfo.centerY = $e.offset().left - $(editor.Canvas.getWindow()).scrollLeft() + $e.height() / 2
            }
          }
        },
        'handleMove': function (e) {
          // console.log('move', e)
          let self = this
          // console.log('self', self)
          // In case the mouse button was released outside of the window
          if (e.which === 0) {
            self.handleEnd(e)
          }
          if (self.dragMove && typeof self.dragInfo === 'object') {
            let el = self.el
            if (self.dragInfo.shift) { // rotation

            } else {

            }
            let comp = self.model
            let $parent = $(comp.parent().view.el)
            let offset = $parent.offset()
            let left = self.dragInfo.initX + e.screenX - self.dragInfo.startX
            let top = self.dragInfo.initY + e.screenY - self.dragInfo.startY
            el.style.left = `${left}px`
            el.style.top = `${top}px`
            // $('.gjs-resizer-c').css({
            //   'left': offset.left + el.style.left,
            //   'top': offset.top + el.style.top
            // })
            $('.gjs-resizer-c').css({ 'display': 'none' })
            let $badge = $('#gjs-tools .gjs-badge')
            // console.log($badge)
            // console.log(self.dragInfo.badgeOffset)
            $badge.css({
              'left': `${Math.max(offset.left + left, 0)}px`,
              'top': `${Math.max(offset.top + top - $badge.height(), 0)}px`
            })
            // editor.select(self.model)
            editor.trigger('change:canvasOffset')
          }
        },
        'handleEnd': function (e) {
          // console.log('end', e)
          let self = this
          if (self.dragMove) {
            if (typeof self.dragInfo === 'object') {
              let comp = self.model
              editor.trigger('change:canvasOffset')
              updateStyleSize(editor, comp)
              $('.gjs-resizer-c').css({ 'display': 'block' })
              self.dragInfo = undefined
            }
            self.dragMove = false
          }
        }
      })
    })

    domc.addType('frame', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': wwjs.i18n('画布块内容'),
          tagName: 'div',
          draggable: '[lj-type=layer]',
          droppable: true,
          traits: [
            ljName,
            ljNoScolling,
            ljFitTo,
            ljStartPosition,
            ljTransition
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el && el.getAttribute && (el.getAttribute('lj-type') === 'frame')) {
            return { type: 'frame' }
          }
        }
      }),
      view: defaultView.extend({
      // onRender () {
      //   $(this.el).css('min-height', '100vh')
      //   if ($.isFunction(defaultView.onRender)) {
      //     defaultView.onRender.apply(this, arguments)
      //   }
      // },
        events: {
          click: function () {
            // console.log('on click:', arguments)
          },
          dblclick: function () {
            // $(this.el).focus()
            // console.log('on dbclick:', arguments)
          }
        // ,
        // focusout: function () {
        //   console.log('on focusout', arguments)
        // }
        }
      })
    })
  }
}
